export default "__VITE_ASSET__Dt6n46Zu__"